import { Chip, SxProps } from "@mui/material";
import { blue, neutral } from "@flat-ui";

interface Props {
  sx?: SxProps;
}

/**
 * A card that summarizes the project info
 */
export function DemoTag({ sx }: Props): JSX.Element {
  return (
    <Chip
      label="DEMO"
      sx={{
        backgroundColor: blue[500],
        color: neutral[0],
        height: "22px",
        minWidth: "60px",
        textTransform: "uppercase",
        letterSpacing: "0.4px",
        textAlign: "center",
        fontWeight: "600",
        fontSize: "11px",
        ...sx,
      }}
    />
  );
}
